import styled from 'styled-components';

import Drawer, { DrawerBody, DrawerHeader } from '@components/Drawer/next';

export const Container = styled.div``;

export const Wrapper = styled.button`
  padding: 8px 19px;
  gap: 8px;
  background: ${({ theme }) => theme.palette.darkGrey};
  border: 1px solid ${({ theme }) => theme.palette.iron};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    justify-content: center;
    padding: 13px 19px;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 542px !important;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  border: 1px solid ${({ theme }) => theme.palette.iron};
  box-shadow: 0px 10px 20px rgba(58, 58, 58, 0.1);
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.white};
  padding-top: 18px;

  &&&& .CalendarDay__selected_start,
  &&&& .CalendarDay__selected_end {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.palette.iron} !important;
    background: ${({ theme }) => theme.palette.lynxWhite} !important;
    background-color: ${({ theme }) => theme.palette.lynxWhite} !important;
  }

  &&&& .CalendarDay__selected_span {
    background-color: ${({ theme }) => theme.palette.lynxWhite};
    background: ${({ theme }) => theme.palette.lynxWhite};
  }
  &&&& .CalendarDay__hovered_span {
    background-color: ${({ theme }) => theme.palette.lynxWhite};
    background: ${({ theme }) => theme.palette.lynxWhite};
    color: ${({ theme }) => theme.palette.black};
  }

  &&&& .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background-color: ${({ theme }) => theme.palette.lynxWhite} !important;
    background: ${({ theme }) => theme.palette.lynxWhite} !important;
    color: ${({ theme }) => theme.palette.black};
    border: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  }

  &&&& .CalendarMonth_verticalSpacing.CalendarMonth_verticalSpacing_1 {
    border-spacing: 0px 3px !important;
  }
  &&&& .CalendarDay__default {
    :not(.CalendarDay__blocked_out_of_range):hover {
      background-color: ${({ theme }) => theme.palette.lynxWhite};
      background: ${({ theme }) => theme.palette.lynxWhite};

      & span {
        background-color: ${({ theme }) => theme.palette.lynxWhite};
        background: ${({ theme }) => theme.palette.lynxWhite};
      }
    }
  }

  &&&& .CalendarMonth_caption > strong {
    color: ${({ theme }) => theme.palette.darkGrey} !important;
    font-weight: 700;
  }

  &&&& .CalendarDay__blocked_out_of_range span {
    color: ${({ theme }) => theme.palette.iron} !important;
  }

  &&& .CalendarDay__today.CalendarDay__selected {
    background: ${({ theme }) => theme.palette.lynxWhite};
    background-color: ${({ theme }) => theme.palette.lynxWhite};

    & span {
      background: ${({ theme }) => theme.palette.lynxWhite};
      background-color: ${({ theme }) => theme.palette.lynxWhite};
    }
  }
`;

export const DatePickerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 27px;
`;

export const MobileDateDrawer = styled(Drawer)`
  ${DrawerBody} {
    padding: 0;
    position: relative;
  }

  &&& .CalendarDay__selected_span {
    background-color: ${({ theme }) => theme.palette.lynxWhite} !important;
    background: ${({ theme }) => theme.palette.lynxWhite} !important;
  }
  &&& .CalendarDay__hovered_span {
    background-color: ${({ theme }) => theme.palette.lynxWhite};
    background: ${({ theme }) => theme.palette.lynxWhite};
    color: ${({ theme }) => theme.palette.black};
  }

  &&&& .CalendarDay__selected_start,
  &&&& .CalendarDay__selected_end {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.palette.iron} !important;
    background: ${({ theme }) => theme.palette.lynxWhite} !important;
    background-color: ${({ theme }) => theme.palette.lynxWhite} !important;
  }

  &&& .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background-color: ${({ theme }) => theme.palette.lynxWhite} !important;
    background: ${({ theme }) => theme.palette.lynxWhite} !important;
    color: ${({ theme }) => theme.palette.black};
    border: 1px solid ${({ theme }) => theme.palette.lightBlueGrey};
  }
  &&& .CalendarMonth_verticalSpacing.CalendarMonth_verticalSpacing_1 {
    border-spacing: 0px 3px !important;
  }

  &&& .CalendarDay__default {
    :not(.CalendarDay__blocked_out_of_range):hover {
      background-color: ${({ theme }) => theme.palette.lynxWhite} !important;
      background: ${({ theme }) => theme.palette.lynxWhite} !important;

      & span {
        background-color: ${({ theme }) => theme.palette.lynxWhite};
        background: ${({ theme }) => theme.palette.lynxWhite};
      }
    }
  }
  ${DrawerHeader} {
    padding: 16px 10px;
    align-items: initial;
    flex-direction: column;
  }

  &&& .CalendarMonth_caption > strong {
    color: ${({ theme }) => theme.palette.darkGrey} !important;
    font-weight: 700;
  }

  &&& .CalendarDay__blocked_out_of_range span {
    color: ${({ theme }) => theme.palette.iron} !important;
  }

  &&& .CalendarDay__today.CalendarDay__selected {
    background: ${({ theme }) => theme.palette.lynxWhite};
    background-color: ${({ theme }) => theme.palette.lynxWhite};

    & span {
      background: 0px ${({ theme }) => theme.palette.lynxWhite};
      background-color: ${({ theme }) => theme.palette.lynxWhite};
    }
  }
`;

export const MobileDrawerHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
`;

export const CalenderDay = styled.span`
  position: relative;
  display: block;
`;
export const CalenderEventDay = styled.span`
  width: 4px;
  height: 4px;
  background-color: ${({ theme }) => theme.palette.coral};
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
`;

export const SearchButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: fixed;
  bottom: 0;
  z-index: 100;
  border-radius: 0 0 8px 8px;
  background: ${({ theme }) => theme.palette.white};
  border-top: 1px solid ${({ theme }) => theme.palette.lynxWhite};
  padding: 10px;
  width: 100%;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 16px 25px;
    position: initial;
  }
`;

export const SearchButton = styled.button`
  width: 100%;
  height: 40px;
  background: ${({ theme }) => theme.palette.persianRed};
  color: ${({ theme }) => theme.palette.white};
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:disabled {
    background: ${({ theme }) => theme.palette.persianRed};
    opacity: 0.2;
    pointer-events: none;
    cursor: not-allowed;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 155px;
  }
`;

export const DateTypesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DateTypesItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const DateTypesLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const DateTypesCircle = styled.div<{ backgroundColor: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ backgroundColor }) => backgroundColor};
`;
